import React from 'react';
import styles from './MaintenancePage.module.css';
import maintenanceIcon from '../assets/images/SiteMaintenance.svg';

const MaintenancePage = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img
                    src={maintenanceIcon}
                    alt='Site Maintenance in Progress'
                    className={styles.icon}
                />
            </div>

            <p className={styles.message}>Thanks for your patience - please check back shortly.</p>
        </div>
    );
};

export { MaintenancePage };
